import { humanize } from './dealerFormat';

/** Status → `admin-badge` variant, for every dealer credit status the admin screens show. */
const CLASS: Record<string, string> = {
  // dealer
  DRAFT: 'neutral',
  ACTIVE: 'approved',
  SUSPENDED: 'rejected',
  // request
  PROFORMA_ISSUED: 'update-requested',
  AWAITING_PAYMENT: 'pending',
  PAID: 'approved',
  REVOKED: 'rejected',
  // buyer credit
  PENDING: 'pending',
  LIVE: 'approved',
  EXPIRED: 'neutral',
  // lot
  EXHAUSTED: 'neutral',
  // user / showroom / pack
  DISABLED: 'neutral',
  INACTIVE: 'neutral',
  // dealer refund
  DUE: 'warning',
  // document
  RENDERED: 'approved',
  SENT: 'approved',
  VOID: 'neutral',
};

/** The text is always shown; colour only reinforces it. */
export default function DealerStatusChip({ status, testId = 'dealer-status' }: { status: string; testId?: string }) {
  return (
    <span className={`admin-badge dealer-badge ${CLASS[status] ?? 'pending'}`} data-testid={testId}>
      {humanize(status)}
    </span>
  );
}
